// extracted by mini-css-extract-plugin
export var perGuestsLabel = "CruiseFareCard-module--per-guests-label--83c2b";